import { QueryClient } from '@tanstack/react-query';

/**
 * Plan §20.6 — react-query client.
 *
 * Defaults pulled from apps/web's pattern: 5-min stale, 30-min cache,
 * single retry on transient failure. Wildswim's verdict + conditions
 * are computed server-side and refresh on a 15-min cron, so a 5-min
 * stale window keeps the UI fresh without burning upstream calls.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 30 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});
